import { useCallback, useEffect, useState } from 'react';

/**
 * Runs fn() whenever `key` changes and returns { data, loading, error, retry }.
 * Data from the previous key is dropped, so a page never shows one entity's
 * values under another entity's header.
 */
export default function useAsync(fn, key, { enabled = true } = {}) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ data: null, loading: enabled, error: null });

  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    setState({ data: null, loading: true, error: null });
    Promise.resolve()
      .then(fn)
      .then(
        (data) => live && setState({ data, loading: false, error: null }),
        (error) => live && setState({ data: null, loading: false, error }),
      );
    return () => {
      live = false;
    };
    // fn is expected to change only with key.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, attempt, enabled]);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);
  return { ...state, retry };
}
